module.exports = __webpack_public_path__ + "static/media/grupodetrabajoseleccionado.86e76cbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/SupervisorChat/grupodetrabajoseleccionado.svg
// module id = 1836
// module chunks = 0